import { render, staticRenderFns } from "./MoveLayer.vue?vue&type=template&id=5a1c8d3b&"
import script from "./MoveLayer.vue?vue&type=script&lang=js&"
export * from "./MoveLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports